import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  isSearch: false,
  textSearch: '',
  isSearchAdvanced: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/search/index.js